export const CLI_RUN_TEST_HYE_GRID_LINK =
  'https://www.lambdatest.com/support/docs/hyperexecute-cli-run-tests-on-hyperexecute-grid/';

export const HYE_INTEGRATION_DOC_LINK =
  'https://www.lambdatest.com/support/docs/hyperexecute-integration-with-ci-cd-tools/';
